import type { AppEntry } from '@/types/app';

/**
 * F2: featured вычисляется, а не хранится в apps.yaml.
 *
 * Правила:
 *   1. Если есть `recentIds` — берём первый id, который реально есть в catalog
 *      и который `live`. Это и есть Smart Hero (F4).
 *   2. Иначе — первый `live` сервис из каталога.
 *   3. Иначе — null (рендерим fallback hero без CTA на конкретный сервис).
 *
 * Чистая функция, тестируема в изоляции.
 */
export function computeFeatured(apps: AppEntry[], recentIds: string[]): AppEntry | null {
  const liveById = new Map<string, AppEntry>();
  for (const a of apps) {
    if (a.status === 'live') liveById.set(a.id, a);
  }

  for (const id of recentIds) {
    const hit = liveById.get(id);
    if (hit) return hit;
  }

  const firstLive = apps.find((a) => a.status === 'live');
  return firstLive ?? null;
}
